import {default as init} from "surveylabJsAssets/chart/charts";
import {setDefaultOptions} from "sdbbJsAssets/chart/charts";

export default function () {
    setDefaultOptions({
        chart: {
            width: 655,
        },
        yAxis: {
            min: 0,
            max: 100,
            showLastLabel: true,
            labels: {
                useHTML: true,
                formatter: function () {
                    return this.value + '%';
                }
            }
        },
        plotOptions: {
            series: {
                stacking: 'normal',
            }
        }
    });

    init();
}